export default "__VITE_ASSET__031ef5f8__"